var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicOff(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    fill: "#5F94D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_231_252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.4736 30.7894H41.5658C41.5658 32.0552 41.2921 33.2354 40.8302 34.296L42.9342 36.3999C43.8921 34.7236 44.4736 32.8249 44.4736 30.7894ZM37.5973 31.0802C37.5973 30.9775 37.6315 30.892 37.6315 30.7894V20.5262C37.6315 17.6868 35.3394 15.3947 32.5 15.3947C29.6605 15.3947 27.3684 17.6868 27.3684 20.5262V20.8341L37.5973 31.0802ZM19.2776 17.1052L17.1052 19.2775L27.3855 29.5578V30.7894C27.3855 33.6289 29.6605 35.921 32.5 35.921C32.8763 35.921 33.2526 35.8697 33.6118 35.7841L36.4513 38.6236C35.2368 39.1881 33.8855 39.5131 32.5 39.5131C27.7789 39.5131 23.4342 35.921 23.4342 30.7894H20.5263C20.5263 36.6223 25.1789 41.446 30.7894 42.2841V47.8947H34.2105V42.2841C35.7671 42.0618 37.2381 41.5144 38.5552 40.7447L45.7223 47.8947L47.8947 45.7223L19.2776 17.1052Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_231_252"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41.0526,
    height: 41.0526,
    fill: "white",
    transform: "translate(11.9736 11.9736)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicOff);
export default __webpack_public_path__ + "static/media/micOff.9f29e4292a9d19485df5286ac63dc330.svg";
export { ForwardRef as ReactComponent };